// @flow

import React from "react";
import classNames from "classnames";
import type { WidgetProps } from "@rjsf/utils";
type Props = $Exact<{
  ...WidgetProps,
  options: Object,
}>;

export function NumberInputWidget(props: Props) {
  function handleChange(event: React.ChangeEventHandler<HTMLInputElement>) {
    const val = parseFloat(event.target.value);
    props.onChange(val);
  }
  return (
    <input
      type="number"
      placeholder={props.placeholder}
      onChange={handleChange}
      value={props.value}
      disabled={props.disabled}
      readOnly={props.readonly}
      min={props?.schema?.minimum}
      max={props?.schema?.maximum}
      className={`form-control ${props.className || ""}`}
    />
  );
}

export default NumberInputWidget;
